import { useEffect, useState } from 'react';

import api from '../../../api/client';
import './CategoryManage.css';

const CategoryManage = () => {
    const [categories, setCategories] = useState<any[]>([]);
    const [keyword, setKeyword] = useState('');
    const [newCategory, setNewCategory] = useState('');
    const [editId, setEditId] = useState<number | null>(null);
    const [editName, setEditName] = useState('');

    const loadCategories = async () => {
        try {
            const { data } = await api.get('/categories', { params: { keyword } });
            setCategories(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error('loadCategories error', e);
        }
    };

    useEffect(() => {
        loadCategories();
    }, []);

    const handleSearch = () => loadCategories();

    const handleInsert = async () => {
        if (!newCategory) {
            alert('카테고리를 입력하세요');
            return;
        }

        try {
            await api.post('/categories', { name: newCategory });
            setNewCategory('');
            loadCategories();
        } catch (e) {
            console.error('insertCategory error', e);
        }
    };

    const handleDelete = async (id: number) => {
        if (!window.confirm('삭제하시겠습니까?')) return;

        try {
            await api.delete(`/categories/${id}`);
            loadCategories();
        } catch (e) {
            console.error('deleteCategory error', e);
        }
    };

    const handleUpdate = async (id: number) => {
        try {
            await api.put(`/categories/${id}`, { name: editName });
            setEditId(null);
            loadCategories();
        } catch (e) {
            console.error('updateCategory error', e);
        }
    };

    return (
        <div className="category-manage">
            <div className="category-top">
                <div className="category-search-wrap">
                    <input
                        type="text"
                        placeholder="카테고리 검색"
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                        className="category-input"
                    />
                    <button className="category-button" onClick={handleSearch}>
                        검색
                    </button>
                </div>

                <div className="category-create-wrap">
                    <input
                        type="text"
                        placeholder="새 카테고리"
                        value={newCategory}
                        onChange={(e) => setNewCategory(e.target.value)}
                        className="category-input"
                    />
                    <button className="category-button" onClick={handleInsert}>
                        등록
                    </button>
                </div>
            </div>

            <div className="category-list">
                {categories.map((category) => (
                    <div className="category-card" key={category.id}>
                        {editId === category.id ? (
                            <>
                                <input
                                    type="text"
                                    value={editName}
                                    onChange={(e) => setEditName(e.target.value)}
                                    className="category-edit-input"
                                />

                                <div className="category-actions">
                                    <button className="save-button" onClick={() => handleUpdate(category.id)}>
                                        저장
                                    </button>
                                    <button className="cancel-button" onClick={() => setEditId(null)}>
                                        취소
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="category-name">{category.name}</div>

                                <div className="category-actions">
                                    <button
                                        className="edit-button"
                                        onClick={() => {
                                            setEditId(category.id);
                                            setEditName(category.name);
                                        }}
                                    >
                                        수정
                                    </button>
                                    <button className="delete-button" onClick={() => handleDelete(category.id)}>
                                        삭제
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CategoryManage;
